export enum GAEcommerceEvent {
    Promotion = 'promotion',
    PromotionClick = 'promotionClick',
    PromotionImpression = 'promotionImpression',
    PromotionView = 'ec:promotionView',
    ProductImpression = 'productImpression',
    ProductClick = 'productClick',
    ProductView = 'productView',
    AddProduct = 'ec:addProduct',
    AddPromo = 'ec:addPromo',
    Purchase = 'uaPurchase',
    Checkout = 'checkout',
    AddToCart = 'addToCart',
}
